var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1f34627680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.125 28.125 L 346.875 28.125 L 346.875 346.875 L 28.125 346.875 Z M 28.125 28.125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6a9aa3d428"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 28.125 C 99.480469 28.125 28.125 99.480469 28.125 187.5 C 28.125 275.519531 99.480469 346.875 187.5 346.875 C 275.519531 346.875 346.875 275.519531 346.875 187.5 C 346.875 99.480469 275.519531 28.125 187.5 28.125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f34627680)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6a9aa3d428)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 28.125 28.125 L 346.875 28.125 L 346.875 346.875 L 28.125 346.875 Z M 28.125 28.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009645",
    d: "M 374.96875 187.484375 C 374.871094 290.664062 291.585938 375 187.390625 374.9375 C 83.890625 374.871094 0.03125 291.332031 0.0625 187.390625 C 0.09375 83.320312 84.304688 0.0625 187.546875 0.03125 C 291.011719 0 374.96875 84.019531 374.96875 187.484375 Z M 219.898438 228.539062 C 219.898438 205.4375 219.863281 182.367188 219.929688 159.265625 C 219.960938 150.527344 216.847656 143.125 210.394531 137.371094 C 200.226562 128.285156 188.40625 126.378906 175.726562 130.859375 C 163.621094 135.148438 155.515625 146.777344 155.578125 159.933594 C 155.835938 205.945312 155.707031 251.960938 155.644531 297.972656 C 155.644531 323.964844 177.917969 328.351562 188.566406 328.320312 C 204.582031 328.257812 220.308594 315.355469 219.992188 296.828125 C 219.578125 274.078125 219.898438 251.292969 219.898438 228.539062 Z M 222.089844 80.902344 C 222.058594 61.710938 206.742188 46.425781 187.515625 46.425781 C 168.257812 46.425781 152.878906 61.839844 152.910156 81.09375 C 152.941406 100.128906 168.480469 115.636719 187.546875 115.636719 C 206.742188 115.636719 222.089844 100.191406 222.089844 80.902344 Z M 222.089844 80.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.147e5f560dd9b0e8eb6781a69bf3ece7.svg";
export { ForwardRef as ReactComponent };